import React from 'react';
import PropTypes from 'prop-types';

/**
 * Metric Card Skeleton Component
 * Loading skeleton for metric cards
 */
export const MetricCardSkeleton = () => (
  <div className="metric-card skeleton">
    <div className="skeleton-header">
      <div className="skeleton-line" style={{ width: '60%', height: '16px' }}></div>
    </div>
    <div className="skeleton-content">
      <div className="skeleton-line" style={{ width: '80%', height: '32px', marginBottom: '8px' }}></div>
      <div className="skeleton-line" style={{ width: '40%', height: '14px' }}></div>
    </div>
  </div>
);

/**
 * Card Skeleton Component
 * Generic loading skeleton for cards
 * @param {Object} props - Component props
 * @param {number} [props.lines] - Number of skeleton lines to display
 */
export const CardSkeleton = ({ lines = 3 }) => (
  <div className="admin-card skeleton">
    {Array.from({ length: lines }).map((_, i) => (
      <div key={i} className="skeleton-line" style={{ width: i === 0 ? '80%' : '60%', height: '16px', marginBottom: i < lines - 1 ? '12px' : 0 }}></div>
    ))}
  </div>
);

CardSkeleton.propTypes = {
  lines: PropTypes.number
};

